const ACCESS_TOKEN_KEY = 'router_admin_access_token'
const REFRESH_TOKEN_KEY = 'router_admin_refresh_token'
const USER_KEY = 'router_admin_user'

export function getToken () {
  try {
    return localStorage.getItem(ACCESS_TOKEN_KEY)
  } catch (e) {
    return null
  }
}

export function isAuthed () {
  return !!getToken()
}

export function setToken (token) {
  try {
    localStorage.setItem(ACCESS_TOKEN_KEY, token)
  } catch (e) {}
}

export function clearToken () {
  try {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
  } catch (e) {}
}

export function setRefreshToken (token) {
  try {
    localStorage.setItem(REFRESH_TOKEN_KEY, token)
  } catch (e) {}
}

export function getRefreshToken () {
  try {
    return localStorage.getItem(REFRESH_TOKEN_KEY)
  } catch (e) {
    return null
  }
}

export function setUser (user) {
  try {
    localStorage.setItem(USER_KEY, JSON.stringify(user || null))
  } catch (e) {}
}

export function getUser () {
  try {
    const raw = localStorage.getItem(USER_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}




// WEBPACK FOOTER //
// ./src/utils/auth.js